export class DeterministicRandom {
  private state: number;

  constructor(state: number) {
    this.state = state >>> 0 || 1;
  }

  next(): number {
    let t = this.state += 0x6D2B79F5;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    const result = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    this.state >>>= 0;
    return result;
  }

  normalish(): number {
    return (this.next() + this.next() + this.next() + this.next() - 2) / 2;
  }

  getState(): number {
    return this.state >>> 0;
  }
}
